import { render, staticRenderFns } from "./graduallyQuestionPaper.vue?vue&type=template&id=3e8292a2&scoped=true"
import script from "./graduallyQuestionPaper.vue?vue&type=script&lang=js"
export * from "./graduallyQuestionPaper.vue?vue&type=script&lang=js"
import style0 from "./graduallyQuestionPaper.vue?vue&type=style&index=0&id=3e8292a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8292a2",
  null
  
)

export default component.exports